export default __webpack_public_path__ + "static/media/Beard_6_C1.6772b800.svg";